import React from 'react'

import IconPhone from '@assets/icons/phone.svg?react'

const HelpBody = () => (
  <div className="text-center">
    <IconPhone className="h-20 w-20 mb-6 mx-auto text-primary-blue help-icon-fixed" />

    <p className="text-lg">
      Please call a HomeWorks Energy specialist at{' '}
      <span className="whitespace-nowrap font-semibold text-primary-blue">(781) 305-3319</span>.
    </p>
  </div>
)

export default HelpBody
